var $211addb72c816ef7$exports = {};
$211addb72c816ef7$exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};


export {$211addb72c816ef7$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
